import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '../ui/badge';

const statusConfig = {
  'Draft': { className: 'bg-slate-100 text-slate-700 border-slate-200' },
  'draft': { className: 'bg-slate-100 text-slate-700 border-slate-200' },
  'Submitted': { className: 'bg-amber-50 text-amber-700 border-amber-200' },
  'submitted': { className: 'bg-amber-50 text-amber-700 border-amber-200' },
  'Signed': { className: 'bg-teal-50 text-teal-700 border-teal-200' },
  'signed': { className: 'bg-teal-50 text-teal-700 border-teal-200' },
  'Expired': { className: 'bg-orange-50 text-orange-700 border-orange-200' },
  'expired': { className: 'bg-orange-50 text-orange-700 border-orange-200' },
  'Declined': { className: 'bg-rose-50 text-rose-700 border-rose-200' },
  'declined': { className: 'bg-rose-50 text-rose-700 border-rose-200' },
  'Sanctioned': { className: 'bg-blue-50 text-blue-700 border-blue-200' },
  'Partially Disbursed': { className: 'bg-amber-50 text-amber-700 border-amber-200' },
  'Disbursed': { className: 'bg-teal-50 text-teal-700 border-teal-200' },
  'Active': { className: 'bg-teal-50 text-teal-700 border-teal-200' },
  'Closed': { className: 'bg-slate-100 text-slate-600 border-slate-200' },
  'Closure Requested': { className: 'bg-orange-50 text-orange-700 border-orange-200' },
  'Written Off': { className: 'bg-rose-50 text-rose-700 border-rose-200' },
  'Cancelled': { className: 'bg-slate-100 text-slate-500 border-slate-200' },
  'Frozen': { className: 'bg-blue-100 text-blue-700 border-blue-300' },
  'Pending': { className: 'bg-amber-50 text-amber-700 border-amber-200' },
  'Paid': { className: 'bg-teal-50 text-teal-700 border-teal-200' },
  'Overdue': { className: 'bg-rose-50 text-rose-700 border-rose-200' },
  'Posted': { className: 'bg-teal-50 text-teal-700 border-teal-200' },
};

export function StatusBadge({ status, onClick, interactive = false, className = '' }) {
  const config = statusConfig[status] || statusConfig['Draft'];
  const clickable = Boolean(onClick) || interactive;
  const display = typeof status === 'string' && status.length
    ? status.charAt(0).toUpperCase() + status.slice(1)
    : status;

  if (clickable) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`inline-flex min-w-[104px] justify-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${config.className} ${className}`}
        data-testid="status-badge-button"
      >
        {display}
      </button>
    );
  }

  return (
    <Badge
      variant="outline"
      className={`min-w-[104px] justify-center text-center leading-tight ${config.className} ${className}`}
    >
      {display}
    </Badge>
  );
}

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  interactive: PropTypes.bool,
  className: PropTypes.string,
};
